import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../../../../../../../consts/api";
import { http } from "../../../../../../../../services/HttpService";

export const useVerticalsReportDetails = (payload, options = {}) => {
  const res = useQuery(
    [QUERY_KEYS.verticalsUsageReportDetails, payload],
    () =>
      http.get(HTTP_ENDPOINTS.verticalsUsageReportDetails(), {
        params: payload,
      }),
    {
      select: (res) => res.data.data,
      ...options,
    },
  );
  return res;
};
